import { AppReducer } from "@/features/applications";
import { AnomalReducer } from "@/features/anomalies";
import { DashReducer } from "@/features/dashboard";
import { IntReducer } from "@/features/internal";
import { TradeReducer } from "@/features/trades";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers } from "redux";
import { RootState } from "./rootState";
import { firestoreReducer } from "redux-firestore";

export default (history: History) =>
  combineReducers<RootState>({
    app: AppReducer,
    int: IntReducer,
    dashboard: DashReducer,
    anomal: AnomalReducer,
    trade: TradeReducer,
    router: connectRouter(history),
    // @ts-ignore
    firestore: firestoreReducer
  });
